import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AddPlaceholderAction, RemoveAlertAction, NewAlertAction, RemovePlaceholderAction } from './alert.action';
import { AlertQuery } from './alert.selectors';
import { AlertInfo, AlertReduxState, PlaceholderEnum } from './alert.redux.state';
import { AlertInfoState, AlertTypeEnum, EventCoordinates } from '../alert.state';

@Injectable()
export class AlertService {
  constructor(private store: Store<AlertReduxState>) {}

  getInfo(placeholder: PlaceholderEnum): Observable<AlertInfoState[]> {
    return this.store.pipe(select(AlertQuery.getAlertInfo, placeholder));
  }

  setInfo(info: AlertInfo) {
    info.timeout = AlertReduxState.getTimeoutOrDefault(info.timeout, info.type);
    info.id = AlertReduxState.getIdOrDefault(info.id);

    this.store.dispatch(new NewAlertAction(info));

    if (info.timeout > 0) {
      setTimeout(() => {
        this.remove(info.id);
      }, info.timeout);
    }
  }

  error(message: string, timeout?: number, eventCoordinates?: EventCoordinates) {
    const info: AlertInfo = {
      type: AlertTypeEnum.Error,
      text: message,
      timeout: timeout,
      eventCoordinates: eventCoordinates,
    };
    this.setInfo(info);
  }

  warn(message: string, timeout?: number, eventCoordinates?: EventCoordinates) {
    const info: AlertInfo = {
      type: AlertTypeEnum.Warning,
      text: message,
      timeout: timeout,
      eventCoordinates: eventCoordinates,
    };
    this.setInfo(info);
  }

  info(message: string, timeout?: number, eventCoordinates?: EventCoordinates) {
    const info: AlertInfo = {
      type: AlertTypeEnum.Info,
      text: message,
      timeout: timeout,
      eventCoordinates: eventCoordinates,
    };
    this.setInfo(info);
  }

  success(message: string, timeout?: number, eventCoordinates?: EventCoordinates) {
    const info: AlertInfo = {
      type: AlertTypeEnum.Success,
      text: message,
      timeout: timeout,
      eventCoordinates: eventCoordinates,
    };
    this.setInfo(info);
  }

  remove(id: number) {
    this.store.dispatch(new RemoveAlertAction(id));
  }

  addPlaceholder(placeholder: PlaceholderEnum) {
    this.store.dispatch(new AddPlaceholderAction(placeholder));
  }

  removePlaceholder(placeholder: PlaceholderEnum) {
    this.store.dispatch(new RemovePlaceholderAction(placeholder));
  }
}
